import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Link from '../../../Core/Link';
import { Category, ArticleTitle, Info, Date, Author, Copy } from '../styles';
import { getDate } from '../../../../utils';
import { InnerLink } from '../../../Core/Link/styles';

import { Card, StyledImage, Content } from './styles';

// * Date is returned as year-month-day, we want Month Day, Year
/*
 * headingData.image: {object} the object that holds all the data for the featured image, url, alt, etc
 * titleShort: {string} shortened version of the title to be displayed in the blog card
 * publishDate: {string} the date the blog was published, in yyyy-mm-dd format. This is passed to the getDate func to return the date in the format to display to the user
 * author: {string} the name of the author that wrote the blog post
 * metaDescription: {string} the body copy that is written to specifically display in the blog card
 * url: {string} the path that the article page is created under
 */

function BlogPost({ className, data, blogUrl, lang }) {
  if (!data) return null;
  const { url, author, publishDate, category, titleShort, headingData } = data;
  return (
    <Link
      to={blogUrl ? `/${blogUrl}/${url}` : `/blog/${url}`}
      className="unstyled blog-post"
      lang={lang}
      noSpan
    >
      <Card className={className}>
        {headingData.image && (
          <StyledImage
            src={headingData.imageExpanded.imageCardSharp}
            alt={headingData.imageExpanded.imageCard.altTag}
            objectFit="cover"
          />
        )}
        <Content>
          <Category>
            {category.map(({ id, text }, index) => (
              <span key={id}>
                {index + 1 === category.length ? `${text}` : `${text}, `}
              </span>
            ))}
          </Category>
          <ArticleTitle className="h4">
            {ReactHtmlParser(titleShort)}
          </ArticleTitle>
          <Info>
            {blogUrl === 'careers-blog' ? null : (
              <Date>{getDate(publishDate)}</Date>
            )}
            {author.map(({ name }, index) => (
              <Author key={`${name[0].text}-${index.toString()}`}>
                {name[0].text}
              </Author>
            ))}
          </Info>
          <Copy className="small">
            {ReactHtmlParser(headingData.teaserTextShortHtml)}
          </Copy>
          <InnerLink>Read more</InnerLink>
        </Content>
      </Card>
    </Link>
  );
}

BlogPost.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape().isRequired,
  blogUrl: PropTypes.string,
  lang: PropTypes.string,
};

BlogPost.defaultProps = {
  className: null,
  blogUrl: null,
  lang: 'en-ca',
};

export default BlogPost;
